// eslint-disable-next-line no-restricted-imports
import {fire, on} from 'delegated-events'
import {fetchSafeDocumentFragment} from '@github-ui/fetch-utils'
// eslint-disable-next-line no-restricted-imports
import {observe} from '@github/selector-observer'

const dataStore = new WeakMap<Element, number>()

// The maximum number of times we should load another page of pinnable items automatically, just
// when the user wants to filter the list of pinnable items
const repoPageLimit = 100

async function loadMoreRepositoryItems(loadMoreButton: HTMLButtonElement) {
  const repositorySelectionComponent = loadMoreButton.closest<HTMLElement>('.js-repository-selection-component')!
  const timesLoaded = dataStore.get(repositorySelectionComponent) || 0
  if (timesLoaded > repoPageLimit) {
    return
  }

  loadMoreButton.textContent = loadMoreButton.getAttribute('data-disable-with')!
  loadMoreButton.disabled = true

  dataStore.set(repositorySelectionComponent, timesLoaded + 1)

  const url = loadMoreButton.getAttribute('data-url')!
  fetchItemsAsync(repositorySelectionComponent, url)

  // This event needs to fire after the data-action is bound
  await Promise.resolve()
  repositorySelectionComponent.dispatchEvent(new CustomEvent('repository-items-loaded'))
}

async function fetchItemsAsync(repositorySelectionComponent: HTMLElement, url: string) {
  const html = await fetchSafeDocumentFragment(document, url)

  repositorySelectionComponent.querySelector<HTMLElement>('.js-more-repository-items-replace-target')!.replaceWith(html)

  // When a page of repository items is loaded into the DOM, update the filtering in case the user
  // has typed a query into the text input
  filterRepositoryItems(repositorySelectionComponent)
}

on('click', '.js-more-repository-items-button', function (event: Event) {
  const button = event.currentTarget as HTMLButtonElement
  loadMoreRepositoryItems(button)
})

observe('.js-more-repository-items-button', {
  constructor: HTMLButtonElement,
  add: loadMoreRepositoryItems,
})

function filterRepositoryItems(repositorySelectionComponent: HTMLElement) {
  fire(repositorySelectionComponent.querySelector<HTMLElement>('.js-repository-items-filter-input')!, 'change')
}
